<template>
    <content-divider-section class="content-divider-section-module" />
</template>

<script>
    import ContentDividerSection from '../../../organisms/ContentDividerSection/ContentDividerSection';

    export default {
        name: 'content-divider-section-module',

        components: { ContentDividerSection },
    };
</script>
